"use strict";
/**
 * @module "ethpm/types"
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lift2 = exports.lift = exports.maybe = void 0;
function maybe(t) {
    return (t !== undefined)
        ? t
        : undefined;
}
exports.maybe = maybe;
function lift(func) {
    return (t) => ((t === undefined)
        ? undefined
        : func(t));
}
exports.lift = lift;
function lift2(func) {
    return (t, u) => ((t === undefined || u === undefined)
        ? undefined
        : func(t, u));
}
exports.lift2 = lift2;
